export default "__VITE_ASSET__TTdTde7x__"